import {
  TEntityResponse,
  TEntityListResponse,
  TDeviceProfileErrorResBody,
  TDeviceProfileErrorSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TDeviceProfileErrorsClient = {
  get(id: string): Promise<TEntityResponse<'device-profile-error', TDeviceProfileErrorResBody> | undefined>;
  list(
    limit: number,
    page: number
  ): Promise<TEntityListResponse<'device-profile-error', TDeviceProfileErrorSummaryResBody> | undefined>;
};

function DeviceProfileErrorsClient(apiClient: TAPIClient): TDeviceProfileErrorsClient {
  return {
    async get(id: string): Promise<TEntityResponse<'device-profile-error', TDeviceProfileErrorResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'device-profile-error', TDeviceProfileErrorResBody>>(
        `/device-profile-errors/${id}`
      );

      if (data && data.type !== 'device-profile-error') {
        throw new Error('Invalid entity type received, expected: device-profile-error, received: ' + data.type);
      }

      return data;
    },
    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'device-profile-error', TDeviceProfileErrorSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'device-profile-error', TDeviceProfileErrorSummaryResBody>>(
        `/device-profile-errors?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'device-profile-error') {
        throw new Error('Invalid entity type received, expected: device-profile-error, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TDeviceProfileErrorsClient, DeviceProfileErrorsClient };
